import { LinearProgress } from 'components/LinearProgress';
import { FC } from 'react';
import { IManagementList } from 'types/Management';

import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ManagementRow } from 'components/Management/ManagementRow';

export interface IManagementListProps extends IManagementList {
  loading: boolean;
}

export const ManagementList: FC<IManagementListProps> = ({
  companyUsers,
  loading,
}) => {
  return (
    <TableContainer component={Paper} elevation={3} sx={{ my: 5 }}>
      {loading && <LinearProgress />}
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Responsável RH</strong>
            </TableCell>
            <TableCell>
              <strong>E-mail corporativo</strong>
            </TableCell>
            <TableCell>
              <Grid container spacing={1}>
                <Grid item alignSelf="center">
                  <strong>Tipo de acesso</strong>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell align="center" width={50}>
              <strong>Ação</strong>
            </TableCell>
          </TableRow>
        </TableHead>

        {companyUsers?.length < 1 && (
          <Typography component="caption">
            <Box textAlign="center">
              Não existem colaboradores cadastrados ainda.
            </Box>
          </Typography>
        )}

        <TableBody>
          {companyUsers?.map((management) => (
            <ManagementRow key={management._id} manager={management} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
